// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_772e1b1e50--layout--ebp_k","breadcrumbs":"_772e1b1e50--breadcrumbs--XRWjv","content":"_772e1b1e50--content--ysj8Z","sidebar":"_772e1b1e50--sidebar--aRRIt"};